<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div
    class="sb-form-item"
    :class="[itemClass, { 'sb-form-item--grouped': grouped }]"
  >
    <div v-if="label && !hideLabel" class="sb-form-item__top-container">
      <SbIcon v-if="icon" class="sb-form-item__icon" :name="icon" />

      <label v-if="label" :id="id" class="sb-form-item__label" :for="labelFor">
        {{ label }}

        <span v-if="isRequired" class="sb-form-item__required" aria-hidden="true">*</span>

        <SbIcon
          v-if="helperIconText"
          v-tooltip="computedTooltip"
          name="circle-help"
          class="sb-form-item__helper-icon-text"
        />
      </label>
      <span
        v-if="helperText && !$slots.helper"
        class="sb-form-item__helper-text"
      >
        {{ helperText }}
      </span>
      <slot name="helper"></slot>
    </div>
    <div class="sb-form-item__body" :class="bodyClass">
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, useSlots } from 'vue'
import SbIcon from '../Icon'
import type { IconName } from '../Icon'
import { Tooltip as vTooltip } from '../../directives'
import type { Placement } from '@popperjs/core'

export type SbFormItemProps = {
  id?: string
  label?: string
  helperIconText?: string
  helperTextAlign?: string
  helperText?: string
  tooltipPosition?: Placement
  labelFor?: string
  icon?: IconName
  grouped?: boolean
  isRequired?: boolean
  hideLabel?: boolean
  itemClass?: string
  bodyClass?: string
}

const props = withDefaults(defineProps<SbFormItemProps>(), {
  grouped: false,
  isRequired: false,
  hideLabel: false,
  helperTextAlign: 'center',
  tooltipPosition: 'top',
  helperIconText: undefined,
  helperText: undefined,
  labelFor: undefined,
  icon: undefined,
  id: undefined,
  label: undefined,
})

const slots = useSlots()

const computedTooltip = computed(() => {
  if (props.helperIconText) {
    return {
      label: props.helperIconText,
      textAlign: props.helperTextAlign,
      position: props.tooltipPosition,
    }
  }
  return null
})

onMounted(() => {
  if (props.helperText && slots.helper) {
    console.warn(
      `[SbFormItem]: If the 'helper slot' and the helper-text property are set, only the contents of the slot will be shown`,
    )
  }
})
</script>
